<template>

  <section class="px-24 mt-10 sm-max:px-8 md-max:mt-10">
    <div class="mb-10 text-center md:mb-14">
      <h3 class="font-bold text-black font-ww-bold" :class="newStyle ? 'text-4xl' : 'text-2xl md:text-3xl xl:text-4xl'"
        v-html="title"></h3>
    </div>

    <div class="grid grid-cols-2 gap-x-4 gap-y-7 lg:gap-x-7 sm-max:gap-2 md-max:space-y-4">

      <div v-for="(review, index) in reviews" :key="review.reviewerName" class="col-span-1 md-max:col-span-2">
        <div class="flex flex-col px-10 py-8 h-full rounded-lg bg-grayReview md-only:p-8 md-max:p-4">
          <div class="space-y-4">
            <nuxt-img
              :class="[(newStyle && index == 0 ? 'lg:block hidden' : ''), newStyle && index != 0 ? 'lg:!mt-0 !mt-4' : '']"
              class="m-auto md-only:my-2" loading="lazy" alt="review-rating" width="148" height="23"
              :src="review.reviewImage"></nuxt-img>
            <h3 :class="newStyle ? 'text-2xl' : 'xl:text-2xl md:text-xl sm-max:text-17 text-lg'"
              class="font-bold text-center md-only:py-4 font-ww-bold" v-html="review.reviewTitle"></h3>
            <div :class="newStyle ? 'text-lg md-max:!leading-6' : 'xl:text-lg sm:text-lg text-14 text-sm md:text-base'"
              class="pb-7 text-center  md-max:px-1 font-ww-regular sm-max:leading-5 sm:leading-26 lg:h-auto md-max:pb-4"
              v-html="review.reviewText">

            </div>
          </div>

          <div class="flex flex-col justify-center items-center mt-4 space-y-2">

            <nuxt-img :class="newStyle && index == 0 ? 'lg:hidden mb-6' : 'hidden'" class="m-auto md-only:my-2"
              loading="lazy" alt="review-rating" width="148" height="23" :src="review.reviewImage"></nuxt-img>

            <nuxt-img class="rounded-full" width="65" height="65" loading="lazy" alt="reviewer-avatar"
              :src="review.reviewerImage"></nuxt-img>
            <div class="text-center" :class="newStyle ? 'md-max:!mt-3 md-max:!mb-3' : ''">
              <h5 class="text-base font-bold leading-4 font-ww-bold"
                :class="newStyle ? 'text-lg' : 'xl:text-lg text-base'" v-html="review.reviewerName"></h5>
              <h6 class="font-ww-regular" :class="newStyle ? 'text-lg' : 'xl:text-lg text-base'"
                v-html="review.reviewerLocation"></h6>
            </div>
          </div>
        </div>
      </div>

    </div>


  </section>

</template>


<script setup>

const props = defineProps({
  newStyle: { type: Boolean, default: false },
  title: {
    type: String,
    default: "Why Coffee Lovers Choose Lifeboost"
  },
  reviews: {
    type: Array,
    default: () => [
      {
        reviewImage: "/assets/images/freebag-rate-5.jpg",
        reviewTitle: "“There Just Is No Better”",
        reviewText: "So smooth, and absolutely no acidity. believe I will have to become a monthly subscriber to bring the cost down even further. When you buy in bulk the price plummets. Do yourselves a favour, come on, you deserve it. Shade grown, hand picked, hand washed, lightly roasted and no pesticides equals this incredible quality.",
        reviewerImage: "/assets/images/freebag-dummy-testimonial-ms.jpg",
        reviewerName: "Sonia P",
        reviewerLocation: "USA"
      },
      {
        reviewImage: "/assets/images/freebag-rate-5.jpg",
        reviewTitle: "“Best Coffee <br class='md-max:hidden'/> " +
          "I’ve Ever Tasted”",
        reviewText: "I’m used to doctoring up my coffee to make it palatable, but with this coffee, I can get away with less sugar/and or creamer. It’s fruity tasting with no bitterness at all. I will definitely be purchasing more!",
        reviewerImage: "/assets/images/freebag-dummy-testimonial-ms.jpg",
        reviewerName: "Ziggy L",
        reviewerLocation: "USA"
      },
      {
        reviewImage: "/assets/images/freebag-rate-5.jpg",
        reviewTitle: "“This Coffee Is Delicious”",
        reviewText: "It is full bodied flavor with a great aroma and the packaging is natural and adorable. It feels great to know that the beans were grown and sustainably harvested from a single source. This makes all the difference! I would definitely purchase this again for my family as well as for gifts for friends. An excellent product!",
        reviewerImage: "/assets/images/freebag-dummy-testimonial-ms.jpg",
        reviewerName: "Chrissy B",
        reviewerLocation: "USA"
      },
      {
        reviewImage: "/assets/images/freebag-rate-5.jpg",
        reviewTitle: "“It Is Smooth, No Bitterness, With Full Bodied Flavor”",
        reviewText: "A bit of cream and this coffee is wonderful. The fact that it is grown on a small farm and the coffee you receive is from just this farm, is what makes this coffee have its wonderful flavor. I am on my second order and am now will be a customer for life.",
        reviewerImage: "/assets/images/freebag-dummy-testimonial-ms.jpg",
        reviewerName: "Nichele G",
        reviewerLocation: "USA"
      },
    ]
  }
})

defineBuilderComponent({
  friendlyName: "Reviews Users",
  canHaveChildren: true,
  inputs: [
    {
      name: "newStyle",
      type: "boolean",
      defaultValue: false,
      friendlyName: "New Style"
    },
    {
      name: "title",
      type: "text",
      defaultValue: "Why Coffee Lovers Choose Lifeboost",
      friendlyName: "Section Title"
    },
    {
      name: "reviews",
      type: "list",
      defaultValue: [
        {
          reviewImage: "/assets/images/freebag-rate-5.jpg",
          reviewTitle: "“There Just Is No Better”",
          reviewText: "So smooth, and absolutely no acidity. believe I will have to become a monthly subscriber to bring the cost down even further. When you buy in bulk the price plummets. Do yourselves a favour, come on, you deserve it. Shade grown, hand picked, hand washed, lightly roasted and no pesticides equals this incredible quality.",
          reviewerImage: "/assets/images/freebag-dummy-testimonial-ms.jpg",
          reviewerName: "Sonia P",
          reviewerLocation: "USA"
        },
        {
          reviewImage: "/assets/images/freebag-rate-5.jpg",
          reviewTitle: "“Best Coffee  I’ve Ever Tasted",
          reviewText: "I’m used to doctoring up my coffee to make it palatable, but with this coffee, I can get away with less sugar/and or creamer. It’s fruity tasting with no bitterness at all. I will definitely be purchasing more!",
          reviewerImage: "/assets/images/freebag-dummy-testimonial-ms.jpg",
          reviewerName: "Ziggy L",
          reviewerLocation: "USA"
        },
        {
          reviewImage: "/assets/images/freebag-rate-5.jpg",
          reviewTitle: "“This Coffee Is Delicious”",
          reviewText: "It is full bodied flavor with a great aroma and the packaging is natural and adorable. It feels great to know that the beans were grown and sustainably harvested from a single source. This makes all the difference! I would definitely purchase this again for my family as well as for gifts for friends. An excellent product!",
          reviewerImage: "/assets/images/freebag-dummy-testimonial-ms.jpg",
          reviewerName: "Chrissy B",
          reviewerLocation: "USA"
        },
        {
          reviewImage: "/assets/images/freebag-rate-5.jpg",
          reviewTitle: "“It Is Smooth, No Bitterness, With Full Bodied Flavor”",
          reviewText: "A bit of cream and this coffee is wonderful. The fact that it is grown on a small farm and the coffee you receive is from just this farm, is what makes this coffee have its wonderful flavor. I am on my second order and am now will be a customer for life.",
          reviewerImage: "/assets/images/freebag-dummy-testimonial-ms.jpg",
          reviewerName: "Nichele G",
          reviewerLocation: "USA"
        }
      ],
      subFields: [
        {
          name: "reviewImage",
          type: "file",
          allowedFileTypes: [
            "jpeg",
            "jpg",
            "png",
            "svg"
          ],
          defaultValue: "/assets/images/freebag-rate-5.jpg",
          required: true
        },
        {
          name: "reviewTitle",
          type: "richText",
          defaultValue: "review title"
        },
        {
          name: "reviewText",
          type: "richText",
          defaultValue: "review text"
        },
        {
          name: "reviewerImage",
          type: "file",
          allowedFileTypes: [
            "jpeg",
            "jpg",
            "png",
            "svg"
          ],
          defaultValue: "/assets/images/freebag-dummy-testimonial-ms.jpg",
          required: true
        },
        {
          name: "reviewerName",
          type: "richText",
          defaultValue: "Reviewer Name"
        },
        {
          name: "reviewerLocation",
          type: "richText",
          defaultValue: "Reviewer Location"
        }
      ]
    }
  ]
});
</script>